import { t } from '../../main/adapters'

export class InvalidCredentialsError extends Error {
  constructor() {
    super(t('ERROR_INVALID_CREDENTIALS'))
    this.name = 'InvalidCredentialsError'
  }
}
